// Presentation only. Authorization still uses the existing validated session and site gate.
export type HubBrand = 'heather-nelson' | 'my4mlife';

export function hubBrandFor(raw: string | null): HubBrand | null {
  if (!raw) return null;
  try {
    const url = new URL(raw);
    if (url.origin !== 'https://sites.daricestrategies.com' || url.username || url.password) return null;
    for (const slug of ['heather-nelson', 'my4mlife'] as const) {
      if (url.pathname === `/${slug}` || url.pathname.startsWith(`/${slug}/`)) return slug;
    }
    return null;
  } catch { return null; }
}

export function isHeatherHub(raw: string | null): boolean {
  return hubBrandFor(raw) === 'heather-nelson';
}
